export const INSUFFICIENT_PERMISSIONS_TOOLTIP = 'You do not have permissions to perform this action'
